module.exports = __webpack_public_path__ + "static/img/from1.42d4f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/from1.jpg
// module id = qWV1
// module chunks = 1